import { render, staticRenderFns } from "./OficinasCaetanoRetailLogoES.vue?vue&type=template&id=32ce739f&scoped=true&"
var script = {}
import style0 from "./OficinasCaetanoRetailLogoES.vue?vue&type=style&index=0&id=32ce739f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ce739f",
  null
  
)

export default component.exports